/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/styles';
import { object } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { Container } from '@material-ui/core';
import ReactHTMLParser from 'react-html-parser';
import { RenderChatAsLink } from '../../../MultiBrandChatController/AigoChatWidgetWrapperV2/popOpenChat';
import { nodeToString } from '../../../MultiBrandChatController/utils/commonUtils';

const styles = (theme) => {
    const { breakpoints: { maxWidth } } = theme;
    return ({
        root: {
            '& .faqs_content': {
                fontSize: '0.8125rem',
                fontFamily: 'Hind, sans-serif',
                fontWeight: '400',
                lineHeight: '1.25rem',
                paddingTop: '15px',
                paddingBottom: '50px',
            },
            '& .faqs_outter_container': {
                maxWidth: '1270px',
                [theme.breakpoints.down(maxWidth?.medium_screen_down)]: {
                    overflowWrap: 'break-word',
                    maxWidth: '720px',
                    paddingLeft: '15px',
                    paddingRight: '15px',
                },
            },
            '& .faq_page_title': {
                color: '#2e2c2c',
                padding: '10px',
                fontSize: '2.8125rem',
                textAlign: 'left',
                fontFamily: 'BebasNeue',
                lineHeight: '1',
            },
            '& h1': {
                lineHeight: '38px',
                fontSize: '2.5rem',
                marginBottom: '0.5rem',
                fontWeight: '500',
                marginTop: '0',
            },
            '& .faqs_container': {
                width: '100%',
            },
            '& .faqs_upper': {
                width: '98%',
                margin: '0 auto',
                paddingTop: '10px',
                paddingBottom: '10px',
            },
            '& .faq_list_link': {
                marginTop: '0',
                marginBottom: '1rem',
                '& ul': {
                    marginLeft: '-40px',
                },
            },
            '& p': {
                marginTop: '20px',
                fontSize: '1rem',
                marginBottom: '10px',
                lineHeight: '1.5em',
            },
            '& li': {
                fontSize: '1rem',
                listStyleType: 'disc',
                color: '#707070',
                padding: '5px 0',
                paddingBottom: '5px',
                fontWeight: '700',
                letterSpacing: '.5px',
                '& a': {
                    textDecoration: 'none',
                    color: '#707070',
                    fontSize: '1rem',
                },
            },
            '& .faqs_lower': {
                color: '#333',
                width: '95%',
                margin: '0 auto',
                fontFamily: 'Hind, sans-serif',
                fontWeight: '400',
                '& h2': {
                    color: '#5D800B',
                    fontSize: '1rem',
                    fontWeight: '500',
                    lineHeight: '1.1',
                    paddingBottom: '5px',
                    marginTop: '0',
                    marginBottom: '0.5rem',
                },
                '& .chatLinkContainer': {
                    fontSize: '1rem',
                    lineHeight: '1.5em',
                    display: 'block',
                    paddingBottom: '10px',
                    marginBotton: '10px',
                },
                '& p': {
                    marginTop: '0',
                    paddingBottom: '10px',
                },
                '& li': {
                    color: '#333',
                    fontSize: '0.8125rem',
                    padding: '0',
                    '& strong': {
                        fontWeight: 'bolder',
                        fontSize: '1rem',
                    },
                },
                '& table': {
                    width: '100%',
                    border: '1px solid',
                    borderCollapse: 'collapse',
                    marginBottom: '20px',
                    '& thead': {
                        fontSize: '1rem',
                        textAlign: 'center',
                    },
                    '& tr': {
                        textAlign: 'center!important',
                    },
                    '& th': {
                        border: '1px solid',
                        textAlign: 'inherit',
                        wordBreak: 'break-all',
                    },
                    '& tbody': {
                        fontSize: '1rem',
                        textAlign: 'center',
                        '& td': {
                            border: '1px solid',
                        },
                    },
                },
                '& a': {
                    color: '#2e2c2c',
                    fontWeight: '700',
                    letterSpacing: '.5px',
                    textDecoration: 'none',
                },
            },
        },
    });
};
const transform = (nod) => {
    if (nod?.type === 'tag' && nod?.name === 'p') {
        const val = nod?.children?.map(nodeToString)?.join('');
        if (val && typeof val === 'string' && val.toLowerCase()?.includes('chat')) {
            return <RenderChatAsLink value={val} />;
        }
    }
    return undefined;
};
const PlantsFaqs = ({ classes, data }) => {
    const { hero = {}, overview } = data;
    return (
        <div className={classes.root}>
            <Container container className="faqs_outter_container">
                <div>
                    <div className="faqs_content">
                        <div role="region" aria-label="FAQs" className="faq_page_title">
                            <h1>{hero?.title}</h1>
                        </div>
                        <div className="faqs_container">
                            <div className="faqs_upper">
                                <ul className="faq_list_link">
                                    <ReactMarkdown
                                        escapeHtml={false}
                                        source={hero?.copy}
                                        renderers={{
                                            text: ({ value }) => {
                                                if (typeof value === 'string' && value?.toLowerCase()?.includes('chat')) {
                                                    return <RenderChatAsLink value={value} />;
                                                }
                                                return value;
                                            },
                                        }}
                                    />
                                </ul>
                            </div>
                            <div className="faqs_lower">
                                {ReactHTMLParser(overview, { transform })}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

PlantsFaqs.propTypes = {
    data: object.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(PlantsFaqs);
